
import React, { useMemo } from "react";
import {
  Autocomplete,
  Checkbox,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AutocompleteCheckboxFixSizeUid = ({
  options = [],
  xValue = [],
  xtabIndex = "",
  xDisabled = false,
  setValue,
  setError,
  objName,
  label,
  placeholder,
}) => {
  const allOptions = useMemo(
    () => [{ Uid: "select-all", Name1: "Select All" }, ...options],
    [options]
  );
  const isAllSelected =
    xValue?.length > 0 &&
    options?.length > 0 &&
    xValue?.length === options?.length;
  const handleChange = (event, newValue) => {
    if (!Array.isArray(newValue)) return;
    const hasSelectAll = newValue.some((item) => item.Uid === "select-all");
    if (hasSelectAll) {
      if (isAllSelected) {
        setValue((prev) => ({ ...prev, [objName]: [] }));
        setError((prev) => ({ ...prev, [objName]: "Promo Loc is Required" }));
      } else {
        const allUids = options?.map((item) => item.Uid);
        setValue((prev) => ({ ...prev, [objName]: allUids }));
        setError((prev) => ({ ...prev, [objName]: "" }));
      }
    } else {
      const selectedUids = newValue.map((item) => item.Uid);
      setValue((prev) => ({ ...prev, [objName]: selectedUids }));
      setError((prev) => ({
        ...prev,
        [objName]: selectedUids ? "" : "Promo Loc is Required",
      }));
    }
  };
  const isSelected = (option) => xValue.includes(option.Uid);
  return (
    <div
      className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={allOptions}
        getOptionLabel={(option) => option?.Name1 || ""}
        value={options?.filter((grp) => xValue?.includes(grp.Uid)) || []}
        isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
        onChange={handleChange}
        disableCloseOnSelect
        PopperComponent={(props) => (
          <Popper
            {...props}
            style={{
              zIndex: 1300,
              width: props.anchorEl ? props.anchorEl.clientWidth : "auto",
            }}
            placement="bottom-start"
          />
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              fontSize: "12px",
              "& .MuiOutlinedInput-root": {
                minHeight: xValue.length > 4 ? "80px !important" : "42px !important",
                height: xValue.length > 4 ? "80px !important" : "42px !important",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
                overflowY: xValue.length > 4 ? "auto !important" : "hidden",
                alignItems: "flex-start",
              },

              "& .MuiAutocomplete-inputRoot": {
                maxHeight: xValue.length > 12 ? "65px" : "40px",
                overflowY: xValue.length > 12 ? "auto !important" : "hidden",
              },

              "& .MuiAutocomplete-input": {
                padding: "10px 6px 10px 8px !important",
              },

              "& .MuiInputBase-input": {
                height: "auto",
              },
            }}
          />
        )}
        renderOption={(props, option, { selected }) => {
          if (option.Uid === "select-all") {
            return (
              <MenuItem
                {...props}
                sx={{
                  height: "31px",
                  minHeight: "31px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  size="small"
                  checked={isAllSelected}
                  indeterminate={
                    xValue?.length > 0 && xValue.length < options?.length
                  }
                />
                <ListItemText
                  primary="Select All"
                  primaryTypographyProps={{
                    fontSize: "12px",
                    lineHeight: "1.2",
                  }}
                />
              </MenuItem>
            );
          }

          return (
            <MenuItem
              {...props}
              sx={{
                height: "31px",
                minHeight: "31px",
                padding: "0 8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Checkbox size="small" checked={isSelected(option)} />
              <ListItemText
                primary={option?.Name1}
                primaryTypographyProps={{
                  fontSize: "12px",
                  lineHeight: "1.2",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
            </MenuItem>
          );
        }}
      />
    </div>
  );
};
export default AutocompleteCheckboxFixSizeUid;